import { useState } from "react";
import { Layout, Menu } from "antd";
import { TransactionOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
const { Sider } = Layout;
const LeftSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={toggleCollapsed}
      width={250}
    >
      <div
        className={`logo flex justify-center h-[56px] my-4 transition-opacity duration-500`}
      >
        {collapsed ? (
          <img src="/LogoSquare.svg" alt="logo" className="" />
        ) : (
          <img src="/LogoSquare.svg" alt="logo" className="" />
        )}
      </div>
      <Menu theme="dark" defaultSelectedKeys={"auto"} mode="inline">
        <Menu.Item key="1" icon={<TransactionOutlined />}>
          <Link to="/admin/doctors">Manage Doctor </Link>
        </Menu.Item>
        <Menu.Item key="2" icon={<TransactionOutlined />}>
          <Link to="/admin/manage-institutes">Manage Institutes</Link>
        </Menu.Item>
        <Menu.Item key="3" icon={<TransactionOutlined />}>
          <Link to="/admin/manage-coupons">Manage Discount codes</Link>
        </Menu.Item>
      </Menu>
      {/* {collapsed ? (
        <MenuUnfoldOutlined className="toggle-icon" onClick={toggleCollapsed} />
      ) : (
        <MenuFoldOutlined className="toggle-icon" onClick={toggleCollapsed} />
      )} */}
    </Sider>
  );
};
export default LeftSidebar;